import React from 'react';
import { PostAdd } from '@material-ui/icons';
import IntlMessages from '../../../utils/IntlMessages';
import { validacionRol } from '../../../../services/service.user';
import { HourglassBottom /* RateReview */ } from '@mui/icons-material';

// const main = [
//   {
//     name: <IntlMessages id={'pages.samplePage'} />,
//     type: 'item',
//     icon: <PostAdd />,
//     link: '/dashboard',
//   },
//   {
//     name: <IntlMessages id={'pages.casos'} />,
//     type: 'item',
//     icon: <PostAdd />,
//     link: '/casos',
//   },
//   {
//     name: <IntlMessages id={'pages.tablaEjemplo'} />,
//     type: 'item',
//     icon: <PostAdd />,
//     link: '/tabla-ejemplo',
//   },
// ];

// const adminMenu = [
//   {
//     name: 'Dashboard',
//     type: 'item',
//     icon: <PostAdd />,
//     link: '/dashboard',
//   },
//   {
//     name: <IntlMessages id={'pages.usuarios'} />,
//     type: 'item',
//     icon: <PostAdd />,
//     link: '/usuarios',
//   },
// ];

// const superMenu = [
//   {
//     name: 'Dashboard',
//     type: 'item',
//     icon: <PostAdd />,
//     link: '/dashboard',
//   },
//   {
//     name: <IntlMessages id={'pages.usuarios'} />,
//     type: 'item',
//     icon: <PostAdd />,
//     link: '/usuarios-super',
//   },
//   {
//     name: <IntlMessages id={'pages.roles'} />,
//     type: 'item',
//     icon: <PostAdd />,
//     link: '/roles-super',
//   },
// ];

const menuPresentacionA = [
  {
    name: <IntlMessages id={'pages.analista.asignaciones'} />,
    type: 'item',
    icon: <PostAdd />,
    link: '/asignaciones',
  },
  /*   {
    name: <IntlMessages id={'pages.analista.reclamos'} />,
    type: 'item',
    icon: <RateReview />,
    link: '/reclamos',
  }, */
  {
    name: <IntlMessages id={'pages.analista.pendientes'} />,
    type: 'item',
    icon: <HourglassBottom />,
    link: '/pendientes',
  },
  // {
  //   name: <IntlMessages id={'pages.analista.buscador'} />,
  //   type: 'item',
  //   icon: <PostAdd />,
  //   link: '/buscador',
  // },
  {
    name: <IntlMessages id={'pages.analista.ayuda'} />,
    type: 'item',
    icon: <PostAdd />,
    link: '/ayuda',
  },
];

const menuPresentacionB = [
  {
    name: <IntlMessages id={'pages.usuarios'} />,
    type: 'item',
    icon: <PostAdd />,
    link: '/usuarios',
  },
];

// const sectionMenu = [
//   {
//     name: 'Pruebas',
//     type: 'section',
//     children: main,
//   },
//   {
//     name: 'Menu Administrador',
//     type: 'section',
//     children: adminMenu,
//   },
//   {
//     name: 'Menu Super',
//     type: 'section',
//     children: superMenu,
//   },
// ];

// const collapseMenu = [
//   {
//     name: 'Pruebas',
//     type: 'collapse',
//     children: main,
//   },
//   {
//     name: 'Menu Administrador',
//     type: 'collapse',
//     children: adminMenu,
//   },
//   {
//     name: 'Menu Super',
//     type: 'collapse',
//     children: superMenu,
//   },
// ];

// const sectionMenuPresentacion = [
//   {
//     name: 'Analista',
//     type: 'collapse',
//     children: menuPresentacionA,
//   },
//   {
//     name: 'Administración',
//     type: 'collapse',
//     children: menuPresentacionB,
//   },
// ];

// const collapseMenuPresentacion = [
//   {
//     name: 'Analista',
//     type: 'collapse',
//     children: menuPresentacionA,
//   },
//   {
//     name: 'Administración',
//     type: 'collapse',
//     children: menuPresentacionB,
//   },
// ];

const dynamicMenu = () => {
  var menu = [];
  menu.push({
    name: 'Analista',
    type: 'collapse',
    children: menuPresentacionA,
  });
  if (validacionRol(['Administrador'])) {
    menu.push({
      name: 'Administración',
      type: 'collapse',
      children: menuPresentacionB,
    });
  }
  return menu;
};

const dynamicMenu2 = user => {
  var menu = [];
  if (user) {
    menu.push({
      name: 'Analista',
      type: 'collapse',
      children: menuPresentacionA,
    });
    if (validacionRol(['Administrador'], user)) {
      menu.push({
        name: 'Administración',
        type: 'collapse',
        children: menuPresentacionB,
      });
    }
  }
  return menu;
};

// export const sidebarNavs = sctionTry();

// export const horizontalDefaultNavs = collapseMenu;

// export const minimalHorizontalMenus = collapseMenu;

// export const sidebarNavs = sectionMenuPresentacion;

// export const horizontalDefaultNavs = collapseMenuPresentacion;

// export const minimalHorizontalMenus = collapseMenuPresentacion;

export const sidebarNavs = dynamicMenu();

export const horizontalDefaultNavs = dynamicMenu();

export const minimalHorizontalMenus = dynamicMenu();

export const minimalHorizontalMenusDynamic = dynamicMenu2;
